import Button from '@/components/Buttons/Button';
import { LanguageSelect } from '@/components/LanguageSelect';
import { avatarTextByLanguage, displayLanguages } from '@/components/Modals/CloneVoiceWizardModal/textByLanguage';
import { Prompt } from '@/components/Prompt';
import { useCreateAvatarStore } from '@/pages/avatar/common/context';
import theme from '@/theme';
import { SupportedLanguage } from '@/utils/types';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

const StyledButton = styled(Button)`
    margin: 0 auto;
    height: 48px;
    width: 200px;

    font-size: 18px;
    font-weight: 600;
    line-height: 28px; /* 155.556% */
`;

const DontNeedScriptButton = styled.div`
    margin: 0 auto;
    color: ${theme.colors.secondary[900]};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.32px;

    cursor: pointer;
`;

const StyledLanguageSelect = styled(LanguageSelect)`
    input,
    .MuiInputBase-root {
        cursor: pointer !important;
    }
`;

const StyledPrompt = styled(Prompt)`
    max-height: 240px;
    overflow: auto;

    * {
        transition-duration: 0ms !important;
    }
`;

interface Props {
    onScriptChange: (script: string) => void;
    onWithoutScript: () => void;
}

export const SelectScript = observer(({ onScriptChange, onWithoutScript }: Props) => {
    const [language, setLanguage] = useState<SupportedLanguage>('english');
    const createAvatarStore = useCreateAvatarStore();

    const handleScriptChange = () => {
        const script = avatarTextByLanguage[createAvatarStore.type][language];
        onScriptChange(script);
    };

    return (
        <>
            <StyledLanguageSelect
                value={language}
                onChange={(nextLanguage: SupportedLanguage) => {
                    createAvatarStore.setFootageScriptLanguage(nextLanguage);
                    setLanguage(nextLanguage);
                }}
            />
            <StyledPrompt
                language={language}
                languages={displayLanguages}
                primaryTextByLanguage={avatarTextByLanguage[createAvatarStore.type]}
                removeTags
            />
            <StyledButton color="secondary" onClick={handleScriptChange}>
                Select script
            </StyledButton>
            <DontNeedScriptButton onClick={onWithoutScript}>I don't need a script</DontNeedScriptButton>
        </>
    );
});
